<template>
  <div id="login-wrapper">
    <img id="logo" src="/images/x-total.jpg" alt="company logo" />
    <el-form :rules="rules" ref="form" :model="form">
      <el-form-item label="Username" prop="username">
        <el-input
          @keyup.native.enter="submit"
          v-model="form.username"
          placeholder="username"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="Password" prop="password">
        <el-input
          @keyup.native.enter="submit"
          type="password"
          v-model="form.password"
          placeholder="password"
          show-password
        ></el-input>
      </el-form-item>
      <el-button type="primary" @click="submit">Login</el-button>
      <el-alert
        v-if="error"
        type="error"
        effect="dark"
        :title="error"
        class="mt-1"
      >
      </el-alert>
    </el-form>
  </div>
</template>

<script>
export default {
  data() {
    // let app_storage = JSON.parse(window.localStorage.getItem("app_storage"));
    return {
      // test: app_storage ? app_storage.user.username : "none",
      error: "",
      form: {
        username: "",
        password: ""
      },
      rules: {
        username: [
          { required: true, message: "Username is required", trigger: "blur" }
        ],
        password: [
          { required: true, message: "Password is required", trigger: "blur" }
        ]
      }
    };
  },
  // computed: {
  //   user() {
  //     return this.$store.getters["auth/user"];
  //   }
  // },
  methods: {
    submit() {
      this.error = "";
      this.$refs["form"].validate(valid => {
        if (!valid) return false;

        this.$store.dispatch("auth/login", this.form).then(resp => {
          if (resp) {
            // this.$store.dispatch("auth/getUserInfo", this.form).then(n => {
            //   alert(n);
            // this.test = "test";
            // let user = window.localStorage.getItem("token");
            // alert(user);
            // this.test = user;
            // let keys = [];
            // for (let i in user) {
            //   keys.push(i);
            // }
            // this.test = keys.join(",");
            // this.test = resp.username;
            // this.$notify({ message: user });
            if (
              this.$store.getters["auth/check"] &&
              typeof this.$route.query == "object" &&
              this.$route.query.redirect
            ) {
              this.$router.push(this.$route.query.redirect);
            } else if (this.$store.getters["auth/check"]) {
              this.$router.push("/");
            }

            // this.$notify({ message: "G" });
            // window.location.href = "/";
            // });
            // this.$store.dispatch("auth/init").then(() => {
            //   alert(this.$store.getters["auth/test"]);
            // });
          } else {
            this.error = "Incorrect username or password";
            this.form.password = "";
          }
        });
      });
    }
  }
  // mounted() {
  //   this.$store.dispatch("auth/init").then(() => {
  //     alert(this.$store.getters["auth/test"]);
  //   });
  // }
};
</script>

<style lang="css" scoped>
#login-wrapper {
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  align-items: center;
  justify-content: center;
  background: #eaeaea;
  width: 100vw;
}
#logo {
  width: 150px;
}
.el-form {
  width: 350px;
  padding: 15px;
  background: #fff;
  margin-top: 30px;
}
@media screen and (max-width: 425px) {
  .el-form {
    width: calc(100vw - 50px);
  }
}
</style>
